<form [formGroup]="ScrutinyPopForm">

    <div class="card-body">
        <div class="card custom-card">
            <div class="col-sm-12 text-center">
                <h6><b>Title</b></h6>
            </div>
            <div class="col-sm-8">
                <div class="form-group">
                    <div class="">
                        <mat-form-field appearance="outline" class="example-full-width mt-2">
                            <mat-label>
                                Scrutiny
                            </mat-label>
                            <!-- <input matInput formControlName="CoGPAm" formControlName="RhEmId" placeholder="CoGPAm"required> -->
                            <mat-select #select56 class="colorblack" formControlName="Srty">
                                <mat-select-filter *ngIf="select56.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CdCode'" [array]="SrtyList"
                                    (filteredReturn)="filteredSrtyList =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredSrtyList" [value]="item.CdCode">
                                    {{item.CdCode}} - {{item.CdDesc}}
                                </mat-option>
                            </mat-select>

                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-sm-8">
                <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>Text</mat-label>
                    <!--  -->
                    <textarea matInput formControlName="Text" rows="4" cols="2" placeholder="Enter text"></textarea>
                </mat-form-field>
            </div>
            <div class="col-sm-12">

                <button type="button"
                    class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                    (click)="submit()">
                    Update</button>
                <button type="button"
                    class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                    (click)="close()">
                    Close
                </button>
            </div>
        </div>
    </div>

</form>